import React from "react";

export default function Loading() {
  return (
    <div style={styles.container}>
      <div style={styles.spinner}></div>
      <div style={styles.text}>Loading...</div>
    </div>
  );
}

const styles = {
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f9f9f9",
  },
  text: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "16px",
    color: "#444",
  },
  spinner: {
    width: "55px",
    height: "55px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3f51b5",
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  },
};

// Add CSS animation manually since inline styles cannot animate
const styleSheet = document.styleSheets[0];
styleSheet.insertRule(`
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
`);
